import Icon from '../components/Icon';

const BookmarkFilled = Icon(
  'bookmark-filled',
  <>
    <path d="M7 2.25A2.75 2.75 0 0 0 4.25 5v16a.75.75 0 0 0 1.122.651L12 17.864l6.628 3.787A.75.75 0 0 0 19.75 21V5A2.75 2.75 0 0 0 17 2.25z" />
  </>
);

export default BookmarkFilled;
